<template>
	<div class="coupon-showcase" v-if="show && coupons.length > 0">
		<div class="coupon-slider">
			<div class="coupon-card" v-for="(coupon, index) in coupons" :key="index"
				:class="{ 'selected': selectedIndex === index }" @click="handleClick(coupon, index)">
				<div :class="['coupon-tag', getCouponTagColor(coupon)]" v-if="getCouponTag(coupon)">
					{{ getCouponTag(coupon) }}
				</div>
				<div class="coupon-check"
					:class="[{ 'checked': selectedIndex === index }, getCouponCheckDisabled(coupon)]">
					<i class="fa fa-check"></i>
				</div>
				<div class="coupon-content">
					<div class="coupon-left">
						<div class="coupon-discount">
							<div class="discount-number">
								{{ (coupon.discountValue * 100) || 0 }}<span class="discount-unit">%</span>
							</div>
							<span class="discount-label">{{ $t('coupon.discount_label') }}</span>
						</div>
						<div class="coupon-info">
							<div class="coupon-title" v-html="$t('coupon.title_html')"></div>
							<div class="coupon-title" v-if="coupon.limitedState === 1">{{ $t('couponLottery.limit_use',
								{
									amount:
										'$49.99'
								}) }}</div>
							<div class="coupon-time">
								<template v-if="isExpired(coupon)">
									<span>{{ $t('coupon.expired_text') }}</span>
								</template>
								<template v-else-if="isUsed(coupon)">
									<span>{{ $t('coupon.used_text') }}</span>
								</template>
								<template v-else>
									<i class="fa fa-clock-o"></i>
									<span>{{ $t('coupon.countdown_prefix') }} {{ getCountdown(coupon.remainingTime)
									}}</span>
								</template>
							</div>
						</div>
					</div>
					<div class="coupon-right">
						<!-- 勾选图标在这里显示 -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CouponBanner',
	props: {
		show: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			selectedIndex: null,
			coupons: [],
			counter: 0
		}
	},
	mounted() {
		this.loadCoupons();
		this.timer = setInterval(() => {
			// 每秒递减每个优惠券的剩余时间
			this.coupons = this.coupons.map(coupon => {
				if (coupon.remainingTime > 0) {
					this.counter++;
					return { ...coupon, remainingTime: coupon.remainingTime - 1 };
				} else {
					return { ...coupon, remainingTime: 0 };
				}
			});
		}, 1000);
	},
	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	},
	methods: {
		getCouponCheckDisabled(coupon) {
			if (this.isExpired(coupon) || this.isUsed(coupon)) {
				return 'coupon-check-disabled';
			}
			return '';
		},
		loadCoupons() {
			this.$axios({
				method: 'get',
				url: '/web/api/coupon/getUserCoupons',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode()
				}
			})
				.then(response => {
					if (response.code === 1000 && response.data) {
						// 兼容后端未返回 createTime 字段时，补充默认时间戳
						this.coupons = response.data;
					}
				})
		},
		handleClick(coupon, index) {
			// 禁止已过期或已使用的卡片被选中
			if (coupon.remainingTime <= 0 || coupon.status === 3 || coupon.status === 2) {
				return;
			}
			const isSelect = this.selectedIndex === index ? null : index;
			this.selectedIndex = isSelect;
			this.$emit('select', isSelect === null ? null : coupon);
		},
		getCouponTagColor(coupon) {
			if (coupon.remainingTime <= 0 || coupon.status === 3 || coupon.status === 2) {
				return 'coupon-tag-gray';
			}

			const remainingSeconds = coupon.remainingTime - this.counter;
			const expiryDate = coupon.expiryDate * 3600;
			if (expiryDate - remainingSeconds <= 3600) {
				return 'coupon-tag-green';
			}
			return 'coupon-tag-green';
		},
		getCountdown(remainingSeconds) {
			let seconds = Math.floor(remainingSeconds);
			const hours = Math.floor(seconds / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const secs = seconds % 60;
			return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
		},
		isExpired(coupon) {
			return coupon.remainingTime <= 0 || coupon.status === 3;
		},
		isUsed(coupon) {
			return coupon.status === 2;
		},
		getCouponTag(coupon) {
			// 优先级：过期 > 已使用 > 有效（HOT）> 有效
			if (this.isExpired(coupon)) {
				return 'Expired';
			}
			if (this.isUsed(coupon)) {
				return 'Used';
			}
			// 有效券，判断是否HOT
			// createTime 单位秒，当前时间单位秒
			const remainingSeconds = coupon.remainingTime - this.counter;
			const expiryDate = coupon.expiryDate * 3600;
			if (expiryDate - remainingSeconds <= 3600) {
				return 'HOT';
			}
			return 'Valid';
		}
	}
}
</script>

<style scoped>
/* 红色斜角标签样式 */
.coupon-tag-red {
	background: linear-gradient(135deg, #ff4444 0%, #ff6b6b 100%);
	color: #fff;
}

/* 优惠券展示区 */
.coupon-showcase {
	margin: 0.2rem 0;
	padding: 0 0.2rem;
	overflow: visible;
}

.coupon-slider {
	display: flex;
	gap: 0.15rem;
	overflow-x: auto;
	overflow-y: visible;
	scroll-behavior: smooth;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: none;
	padding-bottom: 0.1rem;
	padding-top: 0.05rem;
}

.coupon-slider::-webkit-scrollbar {
	display: none;
}

/* 优惠券卡片 - 简洁白色设计 */
.coupon-card {
	position: relative;
	min-width: 4rem;
	flex-shrink: 0;
	border-radius: 0.1rem;
	padding: 0.18rem 0.2rem;
	cursor: pointer;
	transition: all 0.3s ease;
	background: #fff;
	border: 2px solid #f5f5f5;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	overflow: hidden;
}

.coupon-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	border-color: #e8e8e8;
}

/* 选中状态 */
.coupon-card.selected {
	border-color: var(--theme-color);
	background: #fffbfb;
	box-shadow: 0 4px 16px rgba(255, 102, 102, 0.2);
}

/* 勾选图标 */
.coupon-check {
	position: absolute;
	top: 50%;
	right: 0.2rem;
	transform: translateY(-50%);
	width: 0.36rem;
	height: 0.36rem;
	border-radius: 50%;
	background: #fff;
	border: 2px solid #ddd;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	z-index: 3;
}

.coupon-check i {
	font-size: 0.16rem;
	color: #fff;
	opacity: 0;
	transform: scale(0);
	transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.coupon-check.checked {
	background: var(--theme-color);
	border-color: var(--theme-color);
	box-shadow: 0 2px 8px rgba(255, 102, 102, 0.4);
}

/* 禁用状态灰色勾选框 */
.coupon-check-disabled {
	background: #f5f5f5 !important;
	border-color: #e7e7e7 !important;
	box-shadow: none !important;
}

.coupon-check-disabled i {
	color: #bdbdbd !important;
}

.coupon-check.checked i {
	opacity: 1;
	transform: scale(1);
}

/* 斜角标签通用样式 */
.coupon-tag {
	position: absolute;
	top: 0.05rem;
	left: -0.20rem;
	width: 0.8rem;
	height: 0.22rem;
	color: #fff;
	font-size: 0.10rem;
	font-weight: bold;
	text-align: center;
	line-height: 0.22rem;
	transform: rotate(-45deg);
	box-shadow: 0 2px 6px rgba(25, 177, 0, 0.10);
	z-index: 2;
	letter-spacing: 0.01rem;
	user-select: none;
	pointer-events: none;
	border-radius: 0.03rem;
	padding: 0;
}

.coupon-tag-green {
	background: linear-gradient(135deg, #19b100 0%, #3edc3a 100%);
}

.coupon-tag-gray {
	background: linear-gradient(135deg, #bdbdbd 0%, #e0e0e0 100%);
	color: #fff;
}

.coupon-tag-red {
	background: linear-gradient(135deg, #ff4444 0%, #ff6b6b 100%);
	color: #fff;
}

/* 卡片内容 */
.coupon-content {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.15rem;
	padding-left: 8px;
}

.coupon-left {
	display: flex;
	align-items: center;
	gap: 0.15rem;
	flex: 1;
}

/* 折扣数字 */
.coupon-discount {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-width: 0.7rem;
	margin-right: 0.15rem;
	position: relative;
}

.discount-number {
	font-size: 0.45rem;
	font-weight: 700;
	line-height: 1;
	color: var(--theme-color);
	font-family: Arial, sans-serif;
	display: flex;
	align-items: flex-start;
}

.discount-unit {
	font-size: 0.16rem;
	font-weight: 700;
	color: var(--theme-color);
	margin-left: 0.02rem;
	line-height: 1;
}

.discount-label {
	font-size: 0.14rem;
	color: var(--theme-color);
	font-weight: 600;
	margin-top: 0.02rem;
}

/* 优惠券信息 */
.coupon-info {
	flex: 1;
	min-width: 0;
	padding-right: 0.5rem;
}

.coupon-title {
	font-size: 0.16rem;
	color: #333;
	margin-bottom: 0.05rem;
	font-weight: 500;
	line-height: 1.3;
}

.coupon-subtitle {
	font-size: 0.14rem;
	color: var(--theme-color);
	font-weight: 600;
	margin-bottom: 0.03rem;
}

.coupon-time {
	font-size: 0.16rem;
	color: var(--theme-color);
	font-weight: 700;
	display: flex;
	align-items: center;
	gap: 0.05rem;
}

.coupon-time i {
	font-size: 0.15rem;
	color: var(--theme-color);
}

/* 右侧按钮 */
.coupon-right {
	flex-shrink: 0;
}

.coupon-btn {
	padding: 0.1rem 0.2rem;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff4444 100%);
	color: #fff;
	border: none;
	border-radius: 0.25rem;
	font-size: 0.13rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s;
	white-space: nowrap;
	box-shadow: 0 2px 8px rgba(255, 68, 68, 0.3);
}

.coupon-btn:hover {
	transform: scale(1.05);
	box-shadow: 0 4px 12px rgba(255, 68, 68, 0.4);
}

.coupon-btn:active {
	transform: scale(0.98);
}


/* 手机端适配 */
@media (max-width: 768px) {
	.coupon-showcase {
		margin: 0.3rem 0;
		padding: 0 0.3rem;
	}

	.coupon-slider {
		gap: 0.25rem;
		padding-bottom: 0.1rem;
	}

	.coupon-card {
		min-width: 6rem;
		padding: 0.25rem;
		border-radius: 0.12rem;
		overflow: hidden;
	}

	.coupon-tag {
		left: -0.28rem;
		top: 0.18rem;
		width: 1rem;
		height: 0.32rem;
		font-size: 0.16rem;
		line-height: 0.32rem;
		border-radius: 0.05rem;
	}

	.coupon-tag-green {
		background: linear-gradient(135deg, #19b100 0%, #3edc3a 100%);
	}

	.coupon-tag-gray {
		background: linear-gradient(135deg, #bdbdbd 0%, #e0e0e0 100%);
		color: #fff;
	}

	.coupon-left {
		gap: 0.25rem;
	}

	.coupon-discount {
		min-width: 1rem;
	}

	.discount-number {
		font-size: 0.7rem;
	}

	.discount-unit {
		font-size: 0.26rem;
	}

	.coupon-divider {
		height: 0.8rem;
	}

	.coupon-title {
		font-size: 0.28rem;
		margin-bottom: 0.08rem;
	}

	.coupon-subtitle {
		font-size: 0.24rem;
		margin-bottom: 0.05rem;
	}

	.coupon-time {
		font-size: 0.28rem;
	}

	.coupon-time i {
		font-size: 0.26rem;
	}

	.coupon-btn {
		padding: 0.16rem 0.3rem;
		font-size: 0.26rem;
		border-radius: 0.35rem;
	}
}
</style>
